export class ApiError extends Error {}
